import { render } from "./Panel.vue?vue&type=template&id=4aced5ea"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__